import { Module } from 'vuex';

import {
  DailyChallengePage,
  DailyChallenge,
  DcMainBody,
  DcFeaturedCourse,
  DcReminderInfo,
  DcClassroom,
  DcProblem,
  DisputeReport,
  DcAttemptResponse,
  DcVisualization,
} from 'frontend/types/daily-challenges';
import { RootState } from 'frontend/types';

const INITIAL_STATE: Module<DailyChallengePage, RootState> = {
  namespaced: true,
  state: {
    dcs: [] as DailyChallenge[],
    dc: {} as DailyChallenge,
    is_locked: false,
    all_dcs_completed: false,
    mainbody: {} as DcMainBody,
    archives_count: 0,
    problem: {},
    featured_course: {} as DcFeaturedCourse,
    dc_tracks: [],
    dc_reminder: {} as DcReminderInfo,
    classrooms: [] as DcClassroom[],
  },
  getters: {
    isLocked: (state: DailyChallengePage): boolean => state.is_locked,
    allDcsCompleted: (state: DailyChallengePage): boolean => state.all_dcs_completed,
    archivesCount: (state: DailyChallengePage): number => state.archives_count,
    featuredCourse: (state: DailyChallengePage): object => state.featured_course,
    dcTracks: (state: DailyChallengePage): object => state.dc_tracks,
    reminder: (state: DailyChallengePage): object => state.dc_reminder,
    visualizations: (state: DailyChallengePage): object => state.mainbody.visualizations || [],
  },
  mutations: {
    setValue(state: DailyChallengePage, value: DailyChallengePage): void {
      Object.assign(state, value);
    },
    setReminder(state: DailyChallengePage, value: DcReminderInfo): void {
      state.dc_reminder = value;
    },
    setClassrooms(state: DailyChallengePage, value: DcClassroom[]): void {
      state.classrooms = value;
    },
    setAttempt(state: DailyChallengePage, value: DcAttemptResponse): void {
      const problem = state.problem as DcProblem;
      problem.completed = value.completed;
      problem.previous_guesses = value.previous_guesses;
      problem.tries_left = value.tries_left;
      problem.answer_is_correct = value.answer_is_correct;
      problem.correct_answer = value.correct_answer;
      problem.raw_correct_answer = value.raw_correct_answer;
      problem.xp_value = value.xp_value;
      problem.earned_xp = value.earned_xp;
      if (value.solution_brief) {
        problem.solution_brief = value.solution_brief;
      }
      state.problem = problem;

      if (value.solution_visualizations) {
        const mainbody = state.mainbody as DcMainBody;
        value.solution_visualizations.forEach((v: DcVisualization) => {
          mainbody.visualizations.push(v);
        });
      }
    },
    setDcReports(state: DailyChallengePage, value: DisputeReport[]): void {
      const problem = state.problem as DcProblem;
      if (value.length) {
        problem.dispute_reports = value;
      }
      state.problem = problem;
    },
  },
  actions: {},
};

export default INITIAL_STATE;
